import axios from '@/core/axios';

import {
  CrmProject,
  CrmProjectsList,
  CrmProjectLostReasonOption,
  CrmProjectSourceOption,
  CrmProjectStageOption
} from './crm-projects.types';

export class CrmProjectsService {
  list(params: Record<string, unknown> = {}): Promise<CrmProjectsList> {
    return axios
      .get<CrmProjectsList>('/crm-projects', { params: { limit: 500, ...params } })
      .then(resp => resp?.data || { values: [], count: 0 });
  }

  get(projectId: number | string): Promise<CrmProject> {
    return axios.get<CrmProject>(`/crm-projects/${projectId}`).then(resp => resp?.data);
  }

  create(project: Partial<CrmProject>): Promise<CrmProject> {
    return axios.post<CrmProject>('/crm-projects', { crm_project: project }).then(resp => resp?.data);
  }

  update(projectId: number | string, project: Partial<CrmProject>): Promise<CrmProject> {
    if (!projectId) throw new Error('Missing project id in update');
    return axios.put<CrmProject>(`/crm-projects/${projectId}`, { crm_project: project }).then(resp => resp?.data);
  }

  delete(projectId: number | string): Promise<void> {
    if (!projectId) throw new Error('Missing project id in delete');
    return axios.delete<void>(`/crm-projects/${projectId}`).then(resp => resp?.data);
  }

  move(projectId: number | string, stage: string, position: number): Promise<CrmProject> {
    return axios.post<CrmProject>(`/crm-projects/${projectId}/move`, { stage, position }).then(resp => resp?.data);
  }

  win(projectId: number | string): Promise<CrmProject> {
    return axios.post<CrmProject>(`/crm-projects/${projectId}/win`).then(resp => resp?.data);
  }

  lose(projectId: number | string, reason: string): Promise<CrmProject> {
    return axios.post<CrmProject>(`/crm-projects/${projectId}/lose`, { reason }).then(resp => resp?.data);
  }

  reopen(projectId: number | string): Promise<CrmProject> {
    return axios.post<CrmProject>(`/crm-projects/${projectId}/reopen`).then(resp => resp?.data);
  }

  stages(): Promise<CrmProjectStageOption[]> {
    return axios.get<CrmProjectStageOption[]>('/crm-projects/stages').then(resp => resp?.data || []);
  }

  sources(): Promise<CrmProjectSourceOption[]> {
    return axios.get<CrmProjectSourceOption[]>('/crm-projects/sources').then(resp => resp?.data || []);
  }

  lostReasons(): Promise<CrmProjectLostReasonOption[]> {
    return axios.get<CrmProjectLostReasonOption[]>('/crm-projects/lost-reasons').then(resp => resp?.data || []);
  }
}

export const crmProjectsService = new CrmProjectsService();
